import { createContext, useContext } from 'react';

export const UserPreferencesContext = createContext();

export const useUserPreferences = () => useContext(UserPreferencesContext);
